import "./style.css";
import { ReactComponent as Check } from "./img/Check.svg";
import { ReactComponent as Error } from "./img/Icon awesome-exclamation-circle.svg";

function ModalSucesso(props) {
  return (
    <section className="modal-sucesso" style={props.status ? {display: "flex"} : {display: "none"}}>
      <div className="modal_content-sucesso">
       {props.tipo? <Check /> : <Error /> } 
        <p className="modal_p-sucesso">{props.content}</p>
        <button className="modal_button-sucesso" onClick={props.ok}>OK</button>
      </div>
    </section>
  )
}

export default ModalSucesso;